// src/pages/agenda/datas.js — datas da Agenda como TEXTO 'AAAA-MM-DD'.
//
// Out/26. A API já entrega data e hora no fuso da operação; aqui a conta é
// só de calendário (somar dias, achar o domingo da semana). Por isso tudo é
// string e Date em UTC: `new Date('2026-10-19')` no navegador de quem está
// em Manaus cairia no dia 18 — com UTC nos dois lados, o dia é o dia.
export const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
export const MES_C = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
export const DC = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
export const DL = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
export const DMINI = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

const p2 = (n) => String(n).padStart(2, '0');
const toD = (s) => { const [y, m, d] = s.split('-').map(Number); return new Date(Date.UTC(y, m - 1, d)); };
const isoD = (d) => `${d.getUTCFullYear()}-${p2(d.getUTCMonth() + 1)}-${p2(d.getUTCDate())}`;

export const add = (s, n) => { const d = toD(s); d.setUTCDate(d.getUTCDate() + n); return isoD(d); };
export const dow = (s) => toD(s).getUTCDay();
export const dnum = (s) => Number(s.slice(8));
export const mon = (s) => Number(s.slice(5, 7)) - 1;
export const yr = (s) => Number(s.slice(0, 4));
export const addMes = (s, n) => {
  let y = yr(s); let m = mon(s) + n;
  y += Math.floor(m / 12); m = ((m % 12) + 12) % 12;
  return `${y}-${p2(m + 1)}-01`;
};
export const cap = (t) => t.charAt(0).toUpperCase() + t.slice(1);
export const hh = (h) => `${p2(Math.floor(h))}:${p2(Math.round((h % 1) * 60) % 60)}`;
export const diaLongo = (s) => `${DL[dow(s)]}, ${dnum(s)} de ${MESES[mon(s)]}`;
export const diaCurto = (s) => `${DL[dow(s)]}, ${dnum(s)} ${MES_C[mon(s)]}`;
export const inicioSemana = (s) => add(s, -dow(s));

// Grade do mês (domingo antes do dia 1º, 5 ou 6 semanas) — a mesma conta no
// mini calendário e na visão Mês.
export function gradeDoMes(cursor) {
  const m0 = `${cursor.slice(0, 7)}-01`;
  const ini = add(m0, -dow(m0));
  const n = add(ini, 35).slice(0, 7) === cursor.slice(0, 7) ? 42 : 35;
  return { ini, n, dias: Array.from({ length: n }, (_, i) => add(ini, i)) };
}

// "Agora" no fuso da operação, sem depender do relógio do navegador estar
// no mesmo fuso. Fuso inválido cai no do navegador em vez de quebrar.
export function agoraNoFuso(fuso) {
  try {
    const partes = new Intl.DateTimeFormat('en-CA', {
      timeZone: fuso || undefined, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(new Date());
    const v = Object.fromEntries(partes.map((p) => [p.type, p.value]));
    const hora = Number(v.hour) % 24;
    return { hoje: `${v.year}-${v.month}-${v.day}`, h: hora + Number(v.minute) / 60 };
  } catch {
    const d = new Date();
    return { hoje: `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`, h: d.getHours() + d.getMinutes() / 60 };
  }
}
